<template>
    <!-- Personal Profile View -->
    <div class="page-layout blank contacts-manage">
        <!-- <div class="row" v-if="ajaxCallinprogress">
            <div class="col-lg-12 py-5 px-3 mt-10">
                <div class="flex-container">
                    <half-circle-spinner :animation-duration="1000" :size="60" color="#005dae" />
                </div>
            </div>
        </div> -->
        <!-- <div class="pb-10" v-if="!ajaxCallinprogress"> -->
        <div class="pb-10">
            <div class="d-flex flex-row flex-wrap justify-content-between align-items-center">
                <div class="breadcrumbactive">
                    <div v-if="basicInformation && !activateEditMode">
                        <span>Profile</span>
                        <a>Basic Info</a>
                    </div>
                    <div v-if="basicInformation && activateEditMode">
                        <span>Profile</span>
                        <span>Basic Info</span>
                        <a>Edit</a>
                    </div>
                    <div v-if="communicationInformation && !activateEditMode">
                        <span>Profile</span>
                        <a>Communication</a>
                    </div>
                    <div v-if="communicationInformation && activateEditMode">
                        <span>Profile</span>
                        <span>Communication</span>
                        <a>Edit</a>
                    </div>
                    <div v-if="preferenceInformation && !activateEditMode">
                        <span>Profile</span>
                        <a>Preferences</a>
                    </div>
                    <div v-if="preferenceInformation && activateEditMode">
                        <span>Profile</span>
                        <span>Preferences</span>
                        <a>Edit</a>
                    </div>
                    <div v-if="addressInformation && !activateEditMode">
                        <span>Profile</span>
                        <a>Address</a>
                    </div>
                    <div v-if="addressInformation && activateEditMode">
                        <span>Profile</span>
                        <span>Address</span>
                        <a>Edit</a>
                    </div>
                    <div v-if="healthInformation && !activateEditMode">
                        <span>Profile</span>
                        <a>Health</a>
                    </div>
                    <div v-if="healthInformation && activateEditMode">
                        <span>Profile</span>
                        <span>Health</span>
                        <a>Edit</a>
                    </div>
                    <div v-if="remindersInformation && !activateEditMode">
                        <span>Profile</span>
                        <a>Reminders</a>
                    </div>
                    <div v-if="remindersInformation && activateEditMode">
                        <span>Profile</span>
                        <span>Reminders</span>
                        <a>Edit</a>
                    </div>
                    <div v-if="productAccess && !activateEditMode">
                        <span>Profile</span>
                        <a>Product Access</a>
                    </div>
                    <div v-if="productAccess && activateEditMode">
                        <span>Profile</span>
                        <span>Product Access</span>
                        <a>Edit</a>
                    </div>
                </div>
                <div class="infoHeader px-3 py-1" style="background: transparent;">
                    <div class="descriptionheader p-0">
                        <div class="description-text-header-left">
                        </div>
                        <div class="description-text-header-right" v-if="!activateEditMode">
                            <!-- <a href="javascript:;" class="btn btn-new-primary btn-smm mr-2"
                                v-if="loggedInUser._id==$route.params.id && activateEditMode == false && digiapps == false && is_product_access_edit"
                                @click="editMode">
                                <i class="icon-pencil pr-1" style="font-size: 16px;"></i>
                                Edit
                            </a> -->
                            <a href="javascript:;" class="btn btn-new-primary btn-smm"
                                v-if="loggedInUser.id==$route.params.id" @click="changePassword">Change Password</a>
                        </div>
                        <div class="description-text-header-right" v-if="activateEditMode">
                            <button class="btn btn-new-danger btn-smm ml-3"
                                style="box-shadow: none !important;min-width: 5rem;" @click="hideEdit">CANCEL</button>
                            <button type="button" @click="updateEditUser" class="btn btn-new-green btn-smm ml-3"
                                style="box-shadow: none;"
                                v-if="!requestResponse && !productAccess && !editevent">SAVE</button>
                            <button type="button" class="btn btn-new-green btn-smm ml-3 disabledbutton"
                                style="box-shadow: none;"
                                v-else-if="requestResponse && !productAccess && !editevent">SAVE</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="profile-block">
                <div class="page-layout-new simple-new left-sidebar-block right-sidebar-block"
                    style="border-radius: 15px;overflow-x: auto">
                    <div class="left-side-div">
                        <div class="digi-sidebar digi-left-positioned digi-open digi-locked-open"
                            style="height:100% !important;">
                            <div class="cover-card">
                                <div class="cover-pic row ml-0 mr-0">
                                    <img class="cover-card-img-top w-full"
                                        :src="profile_data.cover_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/coverpic3.jpg'"
                                        alt="Cover Picture" style="height: 180px;" />
                                    <div class="pl-2 pt-1 pointer profile-background-upload"
                                        v-if="loggedInUser.id==$route.params.id">
                                        <label
                                            class="icon icon-picture text-white d-block fs-14 pr-1 w-100 pointer pl-1"
                                            style="line-height: 21px;">
                                            <input type="file" ref="myCoverPic"
                                                accept="image/x-png, image/gif, image/jpeg"
                                                @change="onUserBackground" />
                                            <span class="ml-2 text-white"
                                                style="font-family: 'Poppins', sans-serif !important;font-size: 12px;font-weight: normal;">
                                                Edit
                                                Photo
                                            </span>
                                        </label>
                                    </div>
                                </div>
                                <div class="cover-card-block wall-person-info">
                                    <a class="person-avatar bg-white pro-img-bordered">
                                        <img class="profileImg"
                                            :src="profile_data.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                            :alt="profile_data.full_name" />
                                        <label class="profilePicEdit" v-if="loggedInUser.id==$route.params.id">
                                            <input type="file" ref="myProfilePic"
                                                accept="image/x-png, image/gif, image/jpeg" id="fileprofile"
                                                @change="onUserProfile" />
                                            <img
                                                src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/editgrey.svg" />
                                        </label>
                                    </a>
                                </div>
                            </div>
                            <div class="digi-content-block px-4 py-2 mt-10">
                                <div class="header pt-4">
                                    <div class="contactInfo">
                                        <div>
                                            <span
                                                class="text-white fw-600 fs-18 contactTitle">{{ profile_data.full_name }}</span>
                                            <div class="my-2 contactTitle">
                                                <i class="crmnew-envelope mr-1 mb-1 text-white iconsize-14"></i>
                                                <span>{{ profile_data.primary_email.value || "-" }}</span>
                                            </div>
                                            <!-- <div
                        class="my-2 mb-4 contactTitle"
                        v-if="profile_data.primary_phone && profile_data.primary_phone.value.phone_number"
                      >
                        <i class="crmnew-phone mr-1 mb-1 text-white iconsize-14"></i>
                        <span>{{ profile_data.primary_phone.value.phone_number }}</span>
                      </div> -->
                                            <div class="px-6" style="border-top: 2px solid #fff;"></div>
                                            <div class="px-3">
                                                <div v-if="account"
                                                    class="d-flex text-white justify-content-center fw-600 fs-14 pt-3 pb-8">
                                                    <img class="profileImg"
                                                        style="width:60px; height:60px; border-radius:50%; border: 1px solid white;"
                                                        :src="profile_data.profile_pic||'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png'"
                                                        :alt="profile_data.first_name" />
                                                    <span class="ml-2">
                                                        <div class="fw-700">
                                                            {{ loggedInUser.hasOwnProperty('company_details') ? 'Business Profile' : 'Personal Profile' }}
                                                        </div>
                                                        <div class=" mt-3 fw-700">
                                                            {{ loggedInUser.company_details.company_name }}</div>
                                                    </span>
                                                </div>
                                                <div v-else class="text-center text-white fw-600 fs-14 pt-3 pb-8">
                                                    <span v-if="loggedInUser.account_type == 'business'">Business Profile</span>
                                                    <span v-else>Personal Profile</span>
                                                </div>
                                                <div v-if="loggedInUser.id != profile_data._id"
                                                    class="d-flex justify-content-center mb-10">
                                                    <button v-if="connectionStatus.following_status == 'follow'"
                                                        class="text-capitalize btn btn-block btn-warning mt-1 mr-3 text-dark"
                                                        style=" border-radius: 3px; background-color: #ffcb73;"
                                                        @click="followUser(profile_data)">Follow</button>
                                                    <button v-if="connectionStatus.following_status == 'following'"
                                                        class="text-capitalize btn btn-block btn-warning mt-1 mr-3 text-dark"
                                                        style=" border-radius: 3px; background-color: #ffcb73;"
                                                        @click="unfollowUser">Unfollow</button>
                                                    <button v-if="connectionStatus.connection_status == 'connect'"
                                                        class="btn btn-block text-capitalize btn-success text-white mt-1"
                                                        @click="connectUser"
                                                        style="border-radius: 3px; background-color: #15b88a;">Connect</button>
                                                    <button v-if="connectionStatus.connection_status == 'requested'"
                                                        class="btn btn-block text-capitalize btn-success mt-1"
                                                        style="color: #a4a4a4 !important; cursor: not-allowed !important; border-radius: 3px; background-color: #ebebeb;">Pending</button>
                                                    <button v-if="connectionStatus.connection_status == 'connected'"
                                                        class="btn btn-block text-capitalize btn-success text-white mt-1"
                                                        @click="disconnectUser(profile_data._id)"
                                                        style="border-radius: 3px; background-color: #15b88a;">Connected</button>
                                                </div>
                                                <div class="d-flex justify-content-center"
                                                    style="cursor:pointer; box-shadow: none;border-radius: 5px;border: solid 0.5px #1eabe5;background-color: #29c2e0;">
                                                    <div class="py-3 mx-1" @click="goToConnections">
                                                        <div class="connection_details">
                                                            <div v-if="profile_data.contact_details" class="count h2 text-white mb-1"
                                                                style="line-height: 1.19;font-size: 16px;">
                                                                {{ profile_data.contact_details.connections_count || 0 }}</div>
                                                            <div class="text-white"
                                                                style="line-height: 1.19;font-size: 14px;">Connections
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span class="mx-1 my-2"
                                                        style="border-right:1px solid #005dae; height: 55px;"></span>
                                                    <div class="py-3 mx-1" @click="goToFollowers">

                                                        <div class="connection_details">
                                                            <div v-if="profile_data.contact_details" class="count h2 text-white mb-1"
                                                                style="line-height: 1.19;font-size: 16px;">
                                                                {{ profile_data.contact_details.followers_count || 0 }}</div>
                                                            <div class="text-white"
                                                                style="line-height: 1.19;font-size: 14px;">Followers
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <span class="mx-1 my-2"
                                                        style="border-right:1px solid #005dae; height: 55px;"></span>
                                                    <div class="py-3 ml-3 mr-3" @click="goToFollowing">

                                                        <div class="connection_details">
                                                            <div v-if="profile_data.contact_details" class="count h2 text-white mb-1"
                                                                style="line-height: 1.19;font-size: 16px;">
                                                                {{ profile_data.contact_details.following_count || 0 }}</div>
                                                            <div class="text-white"
                                                                style="line-height: 1.19; font-size:14px">Following
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="mt-6 contactTitle"
                                                v-if="loggedInUser.id!=$route.params.id && $route.params.id!==undefined">
                                                <div class>
                                                    <span
                                                        v-if="connectionStatus.connection_status=='pending'&&connectionStatus.sent_by==loggedInUser.id&&connectionStatus.sent_to==$route.params.id">
                                                        <button type="button"
                                                            class="btn btn-warning btn-smm text-white mx-4 mb-3"
                                                            v-if="!requestResponse"
                                                            @click="changeConnectionStatus('delete', connectionStatus._id)">REQUEST
                                                            SENT</button>
                                                        <button type="button"
                                                            class="btn btn-warning btn-smm text-white mx-4 mb-3 disabledbutton"
                                                            v-else>REQUEST SENT</button>
                                                    </span>
                                                    <span v-else-if="connectionStatus.connection_status=='connected'">
                                                        <button type="button" class="btn btn-danger btn-smm mx-4 mb-3"
                                                            v-if="!requestResponse"
                                                            @click="changeConnectionStatus('disconnected', connectionStatus._id)">DISCONNECT</button>
                                                        <button type="button"
                                                            class="btn btn-danger btn-smm mx-4 mb-3 disabledbutton"
                                                            v-else>DISCONNECT</button>
                                                    </span>

                                                    <span
                                                        v-else-if="connectionStatus.connection_status=='pending'&&(connectionStatus.sent_to==loggedInUser.id&&connectionStatus.sent_by==$route.params.id)">
                                                        <button type="button"
                                                            class="btn btn-grey-outline btn-smm mx-4 mb-3"
                                                            v-if="!requestResponse"
                                                            @click="changeConnectionStatus('connected', connectionStatus._id)">PENDING</button>
                                                        <button type="button"
                                                            class="btn btn-grey-outline btn-smm mx-4 mb-3 disabledbutton"
                                                            v-else>PENDING</button>
                                                    </span>
                                                    <span v-else>
                                                    </span>
                                                    <button type="button" class="btn btn-grey-invited btn-smm mx-4 mb-3"
                                                        v-if="account != null && empStatus == 'pending'"
                                                        disabled="disabled"
                                                        style="color: #fff !important;">INVITED</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="center-section "
                        style="min-width: 65em;background-color:transparent !important;border:none !important;">
                        <div class="w-100" style="overflow-x: auto; overflow-y: hidden">
                            <div class="d-flex align-items-center">
                                <!-- <div class='new-headings-profile d-flex align-items-center justify-content-center'
                                    :class="{'activeTab':toShow == 'profile','new-blue':toShow == 'profile'}"
                                    @click="changeEditModelView('editBasicInfoView')">
                                    <i class="crmnew-user iconsize-16 mr-4 text-grey-new-pro" :class="{'text-white':toShow == 'profile'}"></i>
                                    Basic Information
                                </div>
                                <div class='new-headings-profile d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'communication','new-blue':toShow == 'communication'}"
                                    @click="changeEditModelView('editCommunicationView')">
                                    <i class="crmnew-phone iconsize-16 mr-4 text-grey-new-pro" :class="{'text-white':toShow == 'communication'}"></i>
                                    Communication
                                </div>
                                <div class='new-headings-profile d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'address','new-blue':toShow == 'address'}"
                                    @click="changeEditModelView('editAddressView')">
                                    <i class="crmnew-marker iconsize-16 mr-4 text-grey-new-pro" :class="{'text-white':toShow == 'address',}"></i>
                                    Address
                                </div>
                                <div class='new-headings-profile d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'preference','new-blue':toShow == 'preference'}"
                                    @click="changeEditModelView('editPreferenceView')">
                                    <i class="crmnew-preference iconsize-16 mr-4 text-grey-new-pro" :class="{'text-white':toShow == 'preference'}"></i>
                                    Preferences
                                </div>
                                <div class='new-headings-profile d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'health','new-blue':toShow == 'health'}"
                                    @click="changeEditModelView('editHealthView')">
                                    <img :src="toShow == 'health' ? 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/health-icon-white.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/health-icon.svg'"
                                        class="activityContact mr-4" style="width: 18px;">
                                    Health
                                </div>
                                <div class='new-headings-profile d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'reminders','new-blue':toShow == 'reminders'}"
                                    @click="changeEditModelView('editRemindersView')">
                                    <img
                                        :src="toShow == 'reminders' ? 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reminders-icon-white.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reminders-icon.svg'"
                                        class="activityContact mr-4" style="width: 18px;">
                                    Reminders
                                </div>
                                <div v-if="loggedInUser.account_type == 'business'" class='new-headings-profile d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'products','new-blue':toShow == 'products'}"
                                    @click="changeEditModelView('editProductAccess')">
                                    <img
                                        :src="toShow == 'products' ? 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/product-access-icon-white.svg' : 'https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/product-access-icon.svg'"
                                        class="activityContact mr-4" style="width: 18px;">
                                    Products Access
                                </div> -->
                                <div class='slant-tabs d-flex align-items-center justify-content-center'
                                    :class="{'activeTab':toShow == 'profile','new-blue':toShow == 'profile'}"
                                    @click="changeEditModelView('editBasicInfoView')">
                                    <i class="crmnew-user iconsize-16 mr-4 defaultDarkBlue"></i>
                                    Basic Information
                                </div>
                                <div class='slant-tabs d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'communication','new-blue':toShow == 'communication'}"
                                    @click="changeEditModelView('editCommunicationView')">
                                    <i class="crmnew-phone iconsize-16 mr-4 defaultDarkBlue"></i>
                                    Communication
                                </div>
                                <div class='slant-tabs d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'address','new-blue':toShow == 'address'}"
                                    @click="changeEditModelView('editAddressView')">
                                    <i class="crmnew-marker iconsize-16 mr-4 defaultDarkBlue"></i>
                                    Address
                                </div>
                                <div class='slant-tabs d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'preference','new-blue':toShow == 'preference'}"
                                    @click="changeEditModelView('editPreferenceView')">
                                    <i class="crmnew-preference iconsize-16 mr-4 defaultDarkBlue"></i>
                                    Preferences
                                </div>
                                <div class='slant-tabs d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'health','new-blue':toShow == 'health'}"
                                    @click="changeEditModelView('editHealthView')">
                                    <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/health-icon-default-blue.svg"
                                        class="activityContact mr-4" style="width: 18px;">
                                    Health
                                </div>
                                <div class='slant-tabs d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'reminders','new-blue':toShow == 'reminders'}"
                                    @click="changeEditModelView('editRemindersView')">
                                    <img data-v-5b5f4586=""
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reminders-icon-default-blue.svg"
                                        class="activityContact mr-4" style="width: 18px;">
                                    Reminders
                                </div>
                                <div class='slant-tabs d-flex align-items-center justify-content-center ml-2'
                                    :class="{'activeTab':toShow == 'products','new-blue':toShow == 'products'}"
                                    @click="changeEditModelView('editProductAccess')">
                                    <img data-v-53ea9f10=""
                                        src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images//product-access-icon-default-blue.svg"
                                        class="activityContact mr-4" style="width: 18px;">
                                    Products Access
                                </div>
                            </div>
                        </div>
                        <div class="center-content">
                            <div class="preview-elements">
                                <div class="tab-content profile-tab-content scroll-media" id="myTabContent"
                                    style="max-height: 49em;">
                                    <div class="" id="basictab" aria-labelledby="basic-tab" v-if="basicInformation">
                                        <!-- <div class="" style="margin: 0 9px;padding: 4px 6px 4px 6px;border-radius: 2.5px;background-color: #fff;">
                                            <i class="crmnew-user iconsize-16 mr-4 defaultDarkBlue"></i>
                                            <span class="fs-14">Basic Information</span>
                                        </div> -->
                                        <personal-info-view :basic_info_data="basic_info_data" v-if="!activateEditMode">
                                        </personal-info-view>
                                        <!-- <edit-personal-info-view @check_tax="checkTax" v-else @updateUserData="updateUserData"
                                            @deactivateEditMode="deactivateEditMode"></edit-personal-info-view> -->
                                    </div>
                                    <div class="" id="communicationtab" aria-labelledby="communication-tab"
                                        v-else-if="communicationInformation">
                                        <!-- <div class="" style="margin: 0 9px;padding: 4px 6px 4px 6px;border-radius: 2.5px;background-color: #fff;">
                                            <i class="crmnew-phone iconsize-16 mr-4 defaultDarkBlue"></i>
                                            <span class="fs-14">Communication</span>
                                        </div> -->
                                        <contact-communication-view>
                                        </contact-communication-view>
                                        <!-- <edit-contact-communication-view v-else @updateUserData="updateUserData"
                                            @deactivateEditMode="deactivateEditMode"></edit-contact-communication-view> -->
                                    </div>
                                    <div class="" id="addresstab" aria-labelledby="address-tab"
                                        v-else-if="addressInformation">
                                        <!-- <div class="" style="margin: 0 9px;padding: 4px 6px 4px 6px;border-radius: 2.5px;background-color: #fff;">
                                            <i class="crmnew-marker iconsize-16 mr-4 defaultDarkBlue"></i>
                                            <span class="fs-14">Address</span>
                                        </div> -->
                                        <contact-address-view>
                                        </contact-address-view>
                                        <!-- <edit-contact-address-view v-else @updateUserData="updateUserData"
                                            @deactivateEditMode="deactivateEditMode"></edit-contact-address-view> -->
                                    </div>
                                    <div class="" id="addresstab" aria-labelledby="address-tab"
                                        v-else-if="preferenceInformation">
                                        <!-- <div class="" style="margin: 0 9px;padding: 4px 6px 4px 6px;border-radius: 2.5px;background-color: #fff;">
                                            <i class="crmnew-preference iconsize-16 mr-4 defaultDarkBlue"></i>
                                            <span class="fs-14">Preferences</span>
                                        </div> -->
                                        <preference-view>
                                        </preference-view>
                                        <!-- <edit-preference-view v-else @updateUserData="updateUserData"
                                            @deactivateEditMode="deactivateEditMode"></edit-preference-view> -->
                                    </div>
                                    <div class="" id="addresstab" aria-labelledby="address-tab"
                                        v-else-if="healthInformation">
                                        <!-- <div class="" style="margin: 0 9px;padding: 4px 6px 4px 6px;border-radius: 2.5px;background-color: #fff;">
                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/health-icon-default-blue.svg" class="activityContact mr-4" style="width: 18px;">
                                            <span class="fs-14">Health</span>
                                        </div> -->
                                        <health-view></health-view>
                                        <!-- <edit-health-view v-else @updateUserData="updateUserData"
                                            @deactivateEditMode="deactivateEditMode"></edit-health-view> -->
                                    </div>
                                    <div class="" id="addresstab" aria-labelledby="address-tab"
                                        v-else-if="remindersInformation">
                                        <!-- <div class="" style="margin: 0 9px;padding: 4px 6px 4px 6px;border-radius: 2.5px;background-color: #fff;">
                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/reminders-icon-default-blue.svg" class="activityContact mr-4" style="width: 18px;">
                                            <span class="fs-14">Reminders</span>
                                        </div> -->
                                        <reminders-view
                                            @showDigiApps="digiapps = true" @hideDigiApps="digiapps = false">
                                        </reminders-view>
                                        <!-- <edit-reminders-view v-else @dataSaved="dataSaved"
                                            @deactivateEditMode="deactivateEditMode" @editEvents="editevent = true"
                                            @closeEditEvents="editevent = false"></edit-reminders-view> -->
                                    </div>
                                    <div class="" id="addresstab" aria-labelledby="address-tab"
                                        v-else-if="productAccess">
                                        <!-- <div class="" style="margin: 0 9px;padding: 4px 6px 4px 6px;border-radius: 2.5px;background-color: #fff;">
                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images//product-access-icon-default-blue.svg" class="activityContact mr-4" style="width: 18px;">
                                            <span class="fs-14">Product Access</span>
                                        </div> -->
                                        <product-access-view :employe_id="employe_id"
                                            :company_id="company_id"></product-access-view>
                                        <!-- <edit-product-access-view v-else @dataSaved="dataSaved"
                                            @deactivateEditMode="deactivateEditMode"></edit-product-access-view> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <change-password modal_name="change_password_modal" @passwordChanged="passwordChanged"></change-password>
        <connect modal_name="connect_modal" :user_name="profile_data.full_name" @sendRequest="sendRequest"
            @AddNote="AddNote"></connect>
        <!-- <send-request modal_name="send_request_modal" :user_name="profile_data.full_name"></send-request> -->
        <add-note modal_name="add_notes_modal" @sendRequest="sendRequest"></add-note>
        <password-changed modal_name="password_changed_modal"></password-changed>
        <save-profile-data v-if="data_saved" modal_name="save_profile_data" @updateUserData="updateUserData"
            @deactivateEditMode="deactivateEditMode"></save-profile-data>
        <following modal_name="following_modal" :follower="follow.by" :following="follow.to"></following>
    </div>
</template>
<script>
    import {
        User
    } from "./mixins/user";
    import Connection from "./mixins/connection";
    import {
        EventBus
    } from "./eventBus/nav-bar-event.js";
    import PersonalInfoView from "./PersonalInfoView";
    import EditPersonalInfoView from "./EditPersonalInfoView";
    import EmployeeList from "./EmployeeList";
    import ContactCommunicationView from "./ContactCommunicationView";
    import EditContactCommunicationView from "./EditContactCommunicationView";
    import ContactAddressView from "./ContactAddressView";
    import EditContactAddressView from "./EditContactAddressView";
    import PreferenceView from "./PreferenceView";
    import EditPreferenceView from "./EditPreferenceView";
    import HealthView from "./HealthView";
    import EditHealthView from "./EditHealthView";
    import RemindersView from "./RemindersView";
    import EditRemindersView from "./EditRemindersView";
    import ProductAccessView from "./ProductAccessView";
    import EditProductAccessView from "./EditProductAccessView";
    import AdminProducts from "./AdminProducts";
    import myUpload from "vue-image-crop-upload";
    import ChangePassword from "./ChangePassword";
    import PasswordChanged from "./alertModals/PasswordChanged";
    // import SendRequest from "./alertModals/SendRequest";
    import AddNote from "./alertModals/AddNote";
    import Connect from "./alertModals/Connect";
    import {
        HalfCircleSpinner
    } from "epic-spinners";
    import QrcodeVue from "qrcode.vue";
    import axios from "axios";
    import SaveProfileData from "./alertModals/SaveProfileData";
    import Following from "./alertModals/Following";
    import Swal from 'sweetalert2';
import profile from './mixins/profile';

    const MAX_SIZE = 512000;
    export default {
        data() {
            return {

                profile_data: {},

                basic_info_data: [],
                is_tax_type: false,
                employe_id: '',
                data_saved: false,
                company_id: '',
                contactTimeline: true,
                is_product_access_edit: true,
                contactAbout: false,
                contactDeals: false,
                contactUpcomingEvents: false,
                show: false,
                userProfile: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/coverpic3.jpg",
                headers: {
                    smail: "*_~",
                },
                toShow: "profile",
                contactActivity: "first",
                contactInfo: "first",
                connectionStatus: {
                    connection_status: null,
                },
                searchkey: "",
                employeeData: [],
                sendInvite: false,
                connectionCount: "",
                requestType: "",
                empStatus: "",
                requestResponse: false,
                basicInformation: true,
                healthInformation: false,
                remindersInformation: false,
                communicationInformation: false,
                addressInformation: false,
                preferenceInformation: false,
                productAccess: false,
                activateEditMode: false,
                userBasicInfo: {
                    first_name: "",
                    full_name: "",
                    last_name: "",
                    middle_name: "",
                    cover_pic: "",
                    profile_pic: "https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/default.png",
                    primary_email: "",
                    primary_phone: {
                        phone_type: "",
                        phone_number: "",
                        country_code: "",
                        dial_code: "",
                    },
                    date_of_birth: "",
                },
                ajaxCallinprogress: false,
                image: {
                    size: "",
                },
                valueqr: "https://example.com",
                size: 90,
                reminderHover: false,
                healthHover: false,
                productHover: false,
                digiapps: false,
                editevent: false,
                follow: {
                    by: "",
                    to: "",
                },
            };
        },
        mixins: [User, Connection, profile],

        components: {
            PersonalInfoView,
            ContactCommunicationView,
            ContactAddressView,
            PreferenceView,
            HealthView,
            RemindersView,
            ProductAccessView,
            "my-upload": myUpload,
            AdminProducts,
            EmployeeList,
            EditPersonalInfoView,
            EditContactCommunicationView,
            EditContactAddressView,
            EditPreferenceView,
            EditHealthView,
            EditRemindersView,
            EditProductAccessView,
            ChangePassword,
            PasswordChanged,
            // SendRequest,
            AddNote,
            HalfCircleSpinner,
            QrcodeVue,
            Connect,
            SaveProfileData,
            Following,
            Swal
        },
        methods: {
            checkTax(value){
                this.is_tax_type = value
            },
            updateUserData() {
                this.data_saved = false;
                setTimeout(() => {
                    this.GetUserData(this.loggedInUser.id);
                    this.activateEditMode = false;
                }, 1000);
            },

            // Edit Mode On
            editMode() {
                this.activateEditMode = true;
            },

            // Deactivate Edit Mode
            deactivateEditMode() {
                if (this.$route.params.id) {
                    this.GetUserData(this.$route.params.id);
                } else {
                    this.GetUserData(this.loggedInUser.id);
                }
                this.activateEditMode = false;
            },

            // Asynchronous Get Connection API
            async getConnectionsCount(id) {
                let res = await this.$http.get("/connections/connection_count?id=" + id);
                if (res.data.status_id == 1) {
                    this.connectionCount = res.data.response;
                }
            },

            // Checking Business and Personal Connection and Redirection Connection Page
            goToConnections() {
                if (this.loggedInUser.id == this.$route.params.id) {
                    var request_type = null;
                    if (this.account) {
                        request_type = "business";
                    } else {
                        request_type = "personal";
                    }
                    var id = this.$route.params.id;
                    if (!id) id = this.loggedInUser.id;
                    this.$router.push({
                        name: "ConnectionList",
                        params: {
                            id: id,
                            request_type: request_type,
                        },
                    });
                }
            },

            // Checking Business and Personal Connection and Redirection Connection Page
            goToFollowers() {
                if (this.loggedInUser.id == this.$route.params.id) {
                    this.$router.push({
                        name: "FollowerList"
                    });
                }
            },

            // Checking Business and Personal Connection and Redirection Connection Page
            goToFollowing() {
                if (this.loggedInUser.id == this.$route.params.id) {
                    this.$router.push({
                        name: "FollowingList"
                    });
                }
            },

            // Checking the permission that his personal profile and show the edit button using loggedInUser ID Store
            editUserProfile() {
                this.$router.push({
                    name: "EditUserProfile",
                    params: {
                        id: this.loggedInUser.id,
                    },
                });
            },

            // Invite Employee Redirection and Route Params ID
            inviteEmployee() {
                this.$router.push({
                    name: "AddEmployee",
                    params: {
                        id: this.$route.params.id,
                    },
                });
            },

            toggleBtn() {
                this.toggleSideBar = !this.toggleSideBar;
            },
            toggleBtn1() {
                this.toggleSideBar = false;
            },
            toggleShow() {
                this.show = !this.show;
            },
            cropSuccess(userProfile, field) {
                this.userProfile = userProfile;
            },
            showEditMap() {
                this.$modal.show("edit_address_modal");
            },

            // Checking Request Type
            getRequestType() {
                if (this.account) {
                    this.requestType = "business";
                } else {
                    this.requestType = "personal";
                }
            },

            // Checking Employee Status Using Permissions from Store
            // checkEmployeeStatus() {
            //   if (
            //     this.account &&
            //     this.$route.params.id &&
            //     this.$route.params.id != this.loggedInUser._id
            //   ) {
            //     this.$http
            //       .post("/employees/check_user_employment_status", {
            //         user_id: this.$route.params.id,
            //       })
            //       .then(result => {
            //         this.empStatus = result.data.response;
            //       });
            //   }
            // },

            // Cover Picture Change Function
            onUserBackground(e) {
                var input = event.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    this.getResumableURLprofile(input.files[0], attachment, "cover_pic");
                }
            },
            // User Profile Image Change Function
            onUserProfile(e) {
                var input = event.target;
                if (input.files && input.files[0]) {
                    const CancelToken = axios.CancelToken;
                    const source = CancelToken.source();
                    let attachment = {
                        name: input.files[0].name,
                        size: JSON.stringify(input.files[0].size),
                        source: source,
                        progress: 0,
                        created_time: new Date(),
                        error: "",
                    };
                    this.getResumableURLprofile(input.files[0], attachment, "profile_pic");
                }
            },
            getResumableURLprofile(file, attachment, type) {
                let data = {
                    file: attachment.name,
                };
                data = new FormData();
                data.append("file", file);
                this.$http
                    .post("https://cloudapis.digicollect.com/external/upload_file", data)
                    .then(response => {
                        if (response.data.status_id == 1) {
                            this.updatePersonalData(response.data.url, type);
                        }
                    })
                    .catch(error => {
                        // this.error = "Error Uploading"
                    });
            },

            // Tabs Switch and Activating View and Edit Mode
            changeEditModelView(editName) {
                this.digiapps = false;

                if (editName == "editBasicInfoView") {
                    this.toShow = 'profile';
                    this.is_product_access_edit = true
                    if (this.activateEditMode == false) {
                        this.basicInformation = true;
                        this.communicationInformation = false;
                        this.addressInformation = false;
                        this.preferenceInformation = false;
                        this.healthInformation = false;
                        this.remindersInformation = false;
                        this.productAccess = false;
                        if (this.editevent == true) {
                            this.editevent = false;
                        }
                        if (this.digiapps == false) {
                            this.digiapps == true
                        }
                    } else {
                        this.$swal({
                            title: "WARNING",
                            text: "There are Unsaved Changes",
                            type: "warning",
                            confirmButtonText: "DISCARD",
                            showCancelButton: true,
                            cancelButtonText: "CANCEL",
                            confirmButtonColor: "#005dae",
                        }).then(result => {
                            if (result.value) {
                                this.basicInformation = true;
                                this.communicationInformation = false;
                                this.addressInformation = false;
                                this.preferenceInformation = false;
                                this.healthInformation = false;
                                this.remindersInformation = false;
                                this.productAccess = false;
                                this.activateEditMode = false;
                                if (this.editevent == true) {
                                    this.editevent = false;
                                }
                                if (this.digiapps == false) {
                                    this.digiapps == true
                                }
                            }
                        });
                    }
                } else if (editName == "editCommunicationView") {
                    this.toShow = 'communication';
                    this.is_product_access_edit = true
                    if (this.activateEditMode == false) {
                        this.basicInformation = false;
                        this.communicationInformation = true;
                        this.addressInformation = false;
                        this.preferenceInformation = false;
                        this.healthInformation = false;
                        this.remindersInformation = false;
                        this.productAccess = false;
                        if (this.editevent == true) {
                            this.editevent = false;
                        }
                    } else {
                        this.$swal({
                            title: "WARNING",
                            text: "There are Unsaved Changes",
                            type: "warning",
                            confirmButtonText: "DISCARD",
                            showCancelButton: true,
                            cancelButtonText: "CANCEL",
                            confirmButtonColor: "#005dae",
                        }).then(result => {
                            if (result.value) {
                                this.basicInformation = false;
                                this.communicationInformation = true;
                                this.addressInformation = false;
                                this.preferenceInformation = false;
                                this.healthInformation = false;
                                this.remindersInformation = false;
                                this.productAccess = false;
                                this.activateEditMode = false;
                                if (this.editevent == true) {
                                    this.editevent = false;
                                }
                            }
                        });
                    }
                } else if (editName == "editAddressView") {
                    this.toShow = 'address';
                    this.is_product_access_edit = true
                    if (this.activateEditMode == false) {
                        this.basicInformation = false;
                        this.communicationInformation = false;
                        this.addressInformation = true;
                        this.preferenceInformation = false;
                        this.healthInformation = false;
                        this.remindersInformation = false;
                        this.productAccess = false;
                        if (this.editevent == true) {
                            this.editevent = false;
                        }
                    } else {
                        this.$swal({
                            title: "WARNING",
                            text: "There are Unsaved Changes",
                            type: "warning",
                            confirmButtonText: "DISCARD",
                            showCancelButton: true,
                            cancelButtonText: "CANCEL",
                            confirmButtonColor: "#005dae",
                        }).then(result => {
                            if (result.value) {
                                this.basicInformation = false;
                                this.communicationInformation = false;
                                this.addressInformation = true;
                                this.preferenceInformation = false;
                                this.healthInformation = false;
                                this.remindersInformation = false;
                                this.productAccess = false;
                                this.activateEditMode = false;
                                if (this.editevent == true) {
                                    this.editevent = false;
                                }
                            }
                        });
                    }
                } else if (editName == "editPreferenceView") {
                    this.toShow = 'preference';
                    this.is_product_access_edit = true
                    if (this.activateEditMode == false) {
                        this.basicInformation = false;
                        this.communicationInformation = false;
                        this.addressInformation = false;
                        this.preferenceInformation = true;
                        this.healthInformation = false;
                        this.remindersInformation = false;
                        this.productAccess = false;
                        if (this.editevent == true) {
                            this.editevent = false;
                        }
                    } else {
                        this.$swal({
                            title: "WARNING",
                            text: "There are Unsaved Changes",
                            type: "warning",
                            confirmButtonText: "DISCARD",
                            showCancelButton: true,
                            cancelButtonText: "CANCEL",
                            confirmButtonColor: "#005dae",
                        }).then(result => {
                            if (result.value) {
                                this.basicInformation = false;
                                this.communicationInformation = false;
                                this.addressInformation = false;
                                this.preferenceInformation = true;
                                this.healthInformation = false;
                                this.remindersInformation = false;
                                this.productAccess = false;
                                this.activateEditMode = false;
                                if (this.editevent == true) {
                                    this.editevent = false;
                                }
                            }
                        });
                    }
                } else if (editName == "editHealthView") {
                    this.toShow = 'health';
                    this.is_product_access_edit = true
                    if (this.activateEditMode == false) {
                        this.basicInformation = false;
                        this.communicationInformation = false;
                        this.addressInformation = false;
                        this.preferenceInformation = false;
                        this.healthInformation = true;
                        this.remindersInformation = false;
                        this.productAccess = false;
                        if (this.editevent == true) {
                            this.editevent = false;
                        }
                    } else {
                        this.$swal({
                            title: "WARNING",
                            text: "There are Unsaved Changes",
                            type: "warning",
                            confirmButtonText: "DISCARD",
                            showCancelButton: true,
                            cancelButtonText: "CANCEL",
                            confirmButtonColor: "#005dae",
                        }).then(result => {
                            if (result.value) {
                                this.basicInformation = false;
                                this.communicationInformation = false;
                                this.addressInformation = false;
                                this.preferenceInformation = false;
                                this.healthInformation = true;
                                this.remindersInformation = false;
                                this.productAccess = false;
                                this.activateEditMode = false;
                                if (this.editevent == true) {
                                    this.editevent = false;
                                }
                            }
                        });
                    }
                } else if (editName == "editRemindersView") {
                    this.toShow = 'reminders';
                    this.is_product_access_edit = true
                    if (this.activateEditMode == false) {
                        this.basicInformation = false;
                        this.communicationInformation = false;
                        this.addressInformation = false;
                        this.preferenceInformation = false;
                        this.healthInformation = false;
                        this.remindersInformation = true;
                        this.productAccess = false;
                        if (this.editevent == true) {
                            this.editevent = false;
                        }
                    } else {
                        this.$swal({
                            title: "WARNING",
                            text: "There are Unsaved Changes",
                            type: "warning",
                            confirmButtonText: "DISCARD",
                            showCancelButton: true,
                            cancelButtonText: "CANCEL",
                            confirmButtonColor: "#005dae",
                        }).then(result => {
                            if (result.value) {
                                this.basicInformation = false;
                                this.communicationInformation = false;
                                this.addressInformation = false;
                                this.preferenceInformation = false;
                                this.healthInformation = false;
                                this.remindersInformation = true;
                                this.productAccess = false;
                                this.activateEditMode = false;
                                if (this.editevent == true) {
                                    this.editevent = false;
                                }
                            }
                        });
                    }
                } else if (editName == "editProductAccess") {
                    this.toShow = 'products';
                    this.is_product_access_edit = false
                    if (this.activateEditMode == false) {
                        this.basicInformation = false;
                        this.communicationInformation = false;
                        this.addressInformation = false;
                        this.preferenceInformation = false;
                        this.healthInformation = false;
                        this.remindersInformation = false;
                        this.productAccess = true;
                        if (this.editevent == true) {
                            this.editevent = false;
                        }
                    } else {
                        this.$swal({
                            title: "WARNING",
                            text: "There are Unsaved Changes",
                            type: "warning",
                            confirmButtonText: "DISCARD",
                            showCancelButton: true,
                            cancelButtonText: "CANCEL",
                            confirmButtonColor: "#005dae",
                        }).then(result => {
                            if (result.value) {
                                this.basicInformation = false;
                                this.communicationInformation = false;
                                this.addressInformation = false;
                                this.preferenceInformation = false;
                                this.healthInformation = false;
                                this.remindersInformation = false;
                                this.productAccess = true;
                                this.activateEditMode = false;
                                if (this.editevent == true) {
                                    this.editevent = false;
                                }
                            }
                        });
                    }
                }
            },

            // Change Password Modal
            changePassword() {
                this.$modal.show("change_password_modal");
            },
            connectUser() {
                this.$modal.show("connect_modal");
            },
            async disconnectUser(id) {
                let res = await this.$http.post("/connections/delete", {
                    _id: id,
                });
                if (res.data.status_id == 1) {
                    window.location.reload();
                }
            },
            AddNote() {
                this.$modal.show("add_notes_modal");
            },
            async sendRequest(note) {
                let params = {
                    connection_status: "requested",
                    message: note ? note : "",
                    sent_to: this.profile_data._id,
                };
                let res = await this.$http.post("/connections/add", params);
                if (res.data.status_id == 1) {
                    // this.$modal.show("send_request_modal");
                    // setTimeout(() => {
                    //     this.$modal.hide("send_request_modal");
                    // }, 1000);
                    // window.location.reload();
                    this.getConnectionStatus({
                        user_id: this.$route.params.id,
                        request_type: this.requestType,
                    });
                }
            },
            passwordChanged() {
                this.$modal.show("password_changed_modal");
            },
            dataSaved() {
                this.data_saved = true;
                setTimeout(() => {
                    this.$modal.show("save_profile_data");
                }, 500);
            },
            async followUser(data) {
                let res = await this.$http.post("/following/add", {
                    sent_to: data._id,
                });
                if (res.data.status_id == 1) {
                    this.follow.by = this.loggedInUser.full_name;
                    this.follow.to = data.full_name;
                    this.$modal.show("following_modal");
                    setTimeout(() => {
                        this.$modal.hide("following_modal");
                    }, 1500);
                    this.getConnectionStatus({
                        user_id: this.$route.params.id,
                    });
                }
            },
            async unfollowUser(id) {
                this.getConnectionStatus({
                    user_id: this.$route.params.id,
                });
                let res = await this.$http.get("/following/unfollow?id=" + this.connectionStatus.following_id);
                if (res.data.status_id == 1) {
                    this.getConnectionStatus({
                        user_id: this.$route.params.id,
                    });
                }
            },
            updateEditUser() {
                if(this.is_tax_type){
                    this.$swal({
                        title: "WARNING",
                        text: "Please Check Tax ID",
                        type: "warning",
                        confirmButtonText: "OK",
                        showCancelButton: false,
                        cancelButtonText: "OK",
                        confirmButtonColor: "#005dae",
                    }).then(result => {
                        if (result.value) {
                        }
                    })
                }
                else{
                    let emit = "";
                    if (this.basicInformation) {
                        emit = "basicInformation";
                    } else if (this.communicationInformation) {
                        emit = "communicationInformation";
                    } else if (this.preferenceInformation) {
                        emit = "preferenceInformation";
                    } else if (this.addressInformation) {
                        emit = "addressInformation";
                    } else if (this.healthInformation) {
                        emit = "healthInformation";
                    } else if (this.remindersInformation) {
                        emit = "remindersInformation";
                    }
                    EventBus.$emit(emit);
                }
            },
            hideEdit() {
                EventBus.$emit("hideuser");
            },
            updateTab(data) {
                if (data == 'profile') {
                    this.basicInformation = true;
                    this.communicationInformation = false;
                    this.addressInformation = false;
                    this.preferenceInformation = false;
                    this.healthInformation = false;
                    this.remindersInformation = false;
                    this.productAccess = false;
                } else if (data == 'communication') {
                    this.basicInformation = false;
                    this.communicationInformation = true;
                    this.addressInformation = false;
                    this.preferenceInformation = false;
                    this.healthInformation = false;
                    this.remindersInformation = false;
                    this.productAccess = false;
                } else if (data == 'address') {
                    this.basicInformation = false;
                    this.communicationInformation = false;
                    this.addressInformation = true;
                    this.preferenceInformation = false;
                    this.healthInformation = false;
                    this.remindersInformation = false;
                    this.productAccess = false;
                } else if (data == 'preference') {
                    this.basicInformation = false;
                    this.communicationInformation = false;
                    this.addressInformation = false;
                    this.preferenceInformation = true;
                    this.healthInformation = false;
                    this.remindersInformation = false;
                    this.productAccess = false;
                } else if (data == 'health') {
                    this.basicInformation = false;
                    this.communicationInformation = false;
                    this.addressInformation = false;
                    this.preferenceInformation = false;
                    this.healthInformation = true;
                    this.remindersInformation = false;
                    this.productAccess = false;
                } else if (data == 'reminders') {
                    this.basicInformation = false;
                    this.communicationInformation = false;
                    this.addressInformation = false;
                    this.preferenceInformation = false;
                    this.healthInformation = false;
                    this.remindersInformation = true;
                    this.productAccess = false;
                } else if (data == 'products') {
                    this.basicInformation = false;
                    this.communicationInformation = false;
                    this.addressInformation = false;
                    this.preferenceInformation = false;
                    this.healthInformation = false;
                    this.remindersInformation = false;
                    this.productAccess = true;
                }
            },
            async updatePersonalData(data, type) {
                try {
                    let param = {};
                    if(type == 'profile_pic') {
                        param.profile_pic = data;
                    } else if(type == 'cover_pic') {
                        param.cover_pic = data;
                    }
                    let response = await this.updatePersonalInfo(param, this.loggedInUser.user_id);
                    if(response.status_id == 1) {
                        this.GetUserData(this.$route.params.id);
                    }
                }
                catch(err) {

                }
            }
        },
        created() {
            this.getRequestType();
            if (this.$route.params.id) {
                this.GetUserData(this.$route.params.id);
                this.getConnectionsCount(this.$route.params.id);
            } else {
                this.$router.push("/userprofile/" + this.loggedInUser.id);
                this.GetUserData(this.loggedInUser.id);
                this.getConnectionsCount(this.loggedInUser.id);
            }
            this.getConnectionStatus({
                user_id: this.$route.params.id,
                request_type: this.requestType,
            });
            // this.changeAccountModelView('accountInfoView');
        },
        mounted() {
            EventBus.$on("toShow", data => {
                this.updateTab(data)
                if (data == 'products') {
                    this.is_product_access_edit = false;
                } else {
                    this.is_product_access_edit = true;
                }
                this.toShow = data;
            });
            EventBus.$on("personal_info_data_update", () => {
                setTimeout(() => {
                    if (this.$route.params.id) {
                        this.GetUserData(this.$route.params.id);
                    } else {
                        this.GetUserData(this.loggedInUser.id);
                    }
                }, 500);
            });
            this.employe_id = this.loggedInUser.user_id;
            this.company_id = this.loggedInUser.company_details ? this.loggedInUser.company_details._id : '';
        },

        // Adding Store Permissions
        computed: {
            loggedInUser() {
                return this.$store.getters.loggedInUser;
            },
            account() {
                return this.$store.getters.account;
            },
            selectedCompany() {
                return this.$store.getters.selectedCompany;
            },
        },
        beforeRouteUpdate(to, from, next) {
            this.activateEditMode = false;
            this.toShow = 'profile';
            this.basicInformation = true;
            this.communicationInformation = false;
            this.addressInformation = false;
            this.preferenceInformation = false;
            const id = to.params.id;
            this.GetUserData(id);
            this.getConnectionsCount(id);
            this.getRequestType();
            this.getConnectionStatus({
                user_id: id,
                request_type: this.requestType,
            });
            this.getConnectionsCount();
            next();
        },
        destroyed() {
            EventBus.$off('toShow');
            EventBus.$off('personal_info_data_update');
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/AccountProfile.vue